import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import {type AxiosResponse } from "axios";
import {type ApplicationContextInterface } from "@@/package/application/applicationContext";
import {AssessmentResultListModel} from "~~/package/mapper/assessment/model/AssessmentResultListModel";
import {AssessmentResultDetailModel} from "~~/package/mapper/assessment/model/AssessmentResultDetailModel";
import {AssessmentAvailableCountModel} from "~~/package/mapper/assessment/model/AssessmentAvailableCountModel";
import type TaskCompleteRequest from "~~/package/apis/learning/request/TaskCompleteRequest";
import {AssessmentKnowledgeSummaryModel} from "~~/package/mapper/assessment/model/AssessmentKnowledgeSummaryModel";
import type AssessmentResponse from "~~/package/apis/assessment/response/AssessmentResponse";
import type ProvisionStatusResponse from "~~/package/apis/assessment/response/ProvisionStatusResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class AssessmentApi {
  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getAssessmentResultList(trackId: number, lang: string): Promise<AxiosResponse<CustomResponse<AssessmentResultListModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentResultListModel>>>('/assessment/result/list/'+trackId,undefined,true, lang);
  }

  public getAssessmentResultDetail(assessmentId: number, lang: string): Promise<AxiosResponse<CustomResponse<AssessmentResultDetailModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentResultDetailModel>>>('/assessment/result/detail/'+assessmentId,undefined,true, lang);
  }

  public getAssessmentAvailableCount(trackId: number): Promise<AxiosResponse<CustomResponse<AssessmentAvailableCountModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentAvailableCountModel>>>('/assessment/available/count/'+trackId,undefined,true);
  }

  public getAssessmentList(trackId: number, lang: string): Promise<AxiosResponse<CustomResponse<AssessmentResponse[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentResponse[]>>>('/assessment/'+trackId,undefined,true, lang);
  }

  public setAssessmentAnswerList(trackId: number, size: number, request: TaskCompleteRequest[]): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, TaskCompleteRequest[]>(`/assessment/save/answer/${trackId}?size=${size}`, request,true);
  }

  public getAssessmentKnowledgeSummaryList(trackId: number, assessmentId: number, lang: string): Promise<AxiosResponse<CustomResponse<AssessmentKnowledgeSummaryModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<AssessmentKnowledgeSummaryModel[]>>>(`/assessment/summary/${trackId}?assessmentId=${assessmentId}`,undefined,true, lang);
  }

  public getProvisionStatus(assessmentId: number): Promise<AxiosResponse<CustomResponse<ProvisionStatusResponse>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProvisionStatusResponse>>>(`/v2/assessments/${assessmentId}/provision-status`,undefined,true);
  }
}
